import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const BioModal = ({ isOpen, onClose, doctor }) => {
  if (!doctor) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <div className="flex flex-col md:flex-row gap-6 items-start">
          <div className="flex-shrink-0">
            <div className="relative w-32 h-40 rounded-lg overflow-hidden border-4 border-teal-200">
              <img
                src={doctor.image}
                alt={`${doctor.name} - ${doctor.title} at Fort Worth Dental`}
                className="w-full h-full object-cover object-top"
                style={{ objectPosition: 'center 20%' }}
              />
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800">{doctor.name}</h3>
            <p className="text-teal-600 font-semibold text-lg">{doctor.title}</p>
            {doctor.specialties && (
              <div className="flex flex-wrap gap-2 mt-3">
                {doctor.specialties.map((specialty, i) => (
                  <span key={i} className="bg-teal-50 text-teal-700 px-3 py-1 rounded-full text-sm">
                    {specialty}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="prose prose-gray max-w-none mt-6">
          {doctor.fullBio && doctor.fullBio.includes('<p>') ? (
            <div className="text-gray-700 leading-relaxed [&_p]:mb-4 [&_strong]:font-bold [&_strong]:text-gray-900" dangerouslySetInnerHTML={{ __html: doctor.fullBio }} />
          ) : (
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">{doctor.fullBio || doctor.bio}</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BioModal;
